'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.bindMapActionCreators = bindMapActionCreators;
exports.mapMiddleware = mapMiddleware;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapMethods = ['setCenter', 'panBy', 'panTo', 'setZoom', 'zoomTo', 'zoomOut', 'zoomIn', 'setBearing', 'rotateTo', 'resetNorth', 'snapToNorth', 'setPitch', 'fitBounds', 'jumpTo', 'flyTo', 'easeTo', 'stop'];

var mapEvents = ['move', 'movestart', 'moveend', 'zoom', 'zoomstart', 'zoomend', 'rotate', 'rotatestart', 'rotateend', 'pitch', 'load'];

var ACTION_TYPE_PREFIX = 'mapbox-';
var SYNC = 'sync';
var SET_SHOW_COLLISION_BOXES = 'setShowCollisionBoxes';
var SET_SHOW_TILE_BOUNDARIES = 'setShowTileBoundaries';
var SET_SHOW_OVERDRAW_INSPECTOR = 'setShowOverdrawInspector';

var specialCases = [SYNC, SET_SHOW_COLLISION_BOXES, SET_SHOW_TILE_BOUNDARIES, SET_SHOW_OVERDRAW_INSPECTOR];

var prefixOutgoingActionType = function prefixOutgoingActionType(actionType) {
  return '' + ACTION_TYPE_PREFIX + actionType;
};
var prefixInternalActionType = function prefixInternalActionType(actionType) {
  return 'internal-' + ACTION_TYPE_PREFIX + actionType;
};

var mapMethodsByInternalActionType = mapMethods.reduce(function (memo, mapMethod) {
  return _extends({}, memo, _defineProperty({}, prefixInternalActionType(mapMethod), mapMethod));
}, {});

var MapActionTypes = exports.MapActionTypes = mapEvents.concat(specialCases).reduce(function (memo, mapEvent) {
  return _extends({}, memo, _defineProperty({}, mapEvent, prefixOutgoingActionType(mapEvent)));
}, {});

var MapActionCreators = exports.MapActionCreators = mapMethods.concat(specialCases).reduce(function (memo, mapMethod) {
  memo[mapMethod] = function (mapId) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return {
      mapId: mapId,
      args: args,
      type: prefixInternalActionType(mapMethod)
    };
  };
  return memo;
}, {});

function bindMapActionCreators(mapId) {
  var boundActionCreators = {};
  for (var mapMethod in MapActionCreators) {
    if (!MapActionCreators.hasOwnProperty(mapMethod)) continue;
    boundActionCreators[mapMethod] = MapActionCreators[mapMethod].bind(null, mapId);
  }
  return boundActionCreators;
}

var registeredMaps = {};

var registeredDispatch = function registeredDispatch() {};

var ReduxMapControl = exports.ReduxMapControl = function () {
  function ReduxMapControl(mapId) {
    _classCallCheck(this, ReduxMapControl);

    this.mapId = mapId;
    this.MapActionCreators = bindMapActionCreators(mapId);
    this._listeners = [];
    this.div = null;
  }

  _createClass(ReduxMapControl, [{
    key: 'onAdd',
    value: function onAdd(map) {
      var mapId = this.mapId,
          _listeners = this._listeners;

      registeredMaps[mapId] = map;
      this.map = map;

      mapEvents.forEach(function (mapEvent) {
        var listener = function listener(eventData) {
          registeredDispatch({
            map: map,
            mapId: mapId,
            eventData: eventData,
            event: mapEvent,
            type: prefixOutgoingActionType(mapEvent)
          });
        };
        map.on(mapEvent, listener);
        _listeners.push([mapEvent, listener]);
      });

      this.div = document.createElement('div');
      return this.div;
    }
  }, {
    key: 'onRemove',
    value: function onRemove() {
      var map = this.map,
          mapId = this.mapId,
          _listeners = this._listeners;

      if (!map) return this;

      _listeners.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            mapEvent = _ref2[0],
            listener = _ref2[1];

        map.off(mapEvent, listener);
      });
      delete registeredMaps[mapId];

      if (this.div && this.div.parentNode) {
        this.div.parentNode.removeChild(this.div);
      }
      this.div = null;

      return this;
    }
  }]);

  return ReduxMapControl;
}();

var syncInternalActionType = prefixInternalActionType(SYNC);
var showCollisionBoxesInternalActionType = prefixInternalActionType(SET_SHOW_COLLISION_BOXES);
var showTileBoundariesInternalActionType = prefixInternalActionType(SET_SHOW_TILE_BOUNDARIES);
var showOverdrawInspectorInternalActionType = prefixInternalActionType(SET_SHOW_OVERDRAW_INSPECTOR);

function mapMiddleware(_ref3) {
  var dispatch = _ref3.dispatch;

  registeredDispatch = dispatch;

  return function (next) {
    return function (action) {
      var map = registeredMaps[action.mapId];
      if (!map) return next(action);

      switch (action.type) {
        case syncInternalActionType:
          registeredDispatch({
            map: map,
            mapId: action.mapId,
            type: prefixOutgoingActionType(SYNC)
          });
          break;
        case showCollisionBoxesInternalActionType:
          map.showCollisionBoxes = action.args[0];
          registeredDispatch({
            map: map,
            mapId: action.mapId,
            type: prefixOutgoingActionType(SET_SHOW_COLLISION_BOXES)
          });
          break;
        case showTileBoundariesInternalActionType:
          map.showTileBoundaries = action.args[0];
          registeredDispatch({
            map: map,
            mapId: action.mapId,
            type: prefixOutgoingActionType(SET_SHOW_TILE_BOUNDARIES)
          });
          break;
        case showOverdrawInspectorInternalActionType:
          map.showOverdrawInspector = action.args[0];
          registeredDispatch({
            map: map,
            mapId: action.mapId,
            type: prefixOutgoingActionType(SET_SHOW_OVERDRAW_INSPECTOR)
          });
          break;
        default:
          if (mapMethodsByInternalActionType[action.type]) {
            map[mapMethodsByInternalActionType[action.type]].apply(map, action.args);
          }
      }

      next(action);
    };
  };
}